import { NgModule } from '@angular/core';
import { GCADAWidgetComponent } from './widget.component';

@NgModule({
    declarations: [
        GCADAWidgetComponent
    ],
    exports     : [
        GCADAWidgetComponent
    ],
})
export class GCADAWidgetModule
{
}
